<template>
  <div>
    <div v-for="(p, index) in productList" class="game-card" :key="index">
      <div class="game-card-title">{{ p.name }}</div>
      <div>
        Phiên:
        <span class="session" v-if="productSession[p._id]">
          {{ productSession[p._id].session }}
        </span>
      </div>
      <div>
        <div>Đếm ngược:</div>
        <div class="countdown-text">
          <Countdown
            v-if="productSession[p._id]"
            :endTime="productSession[p._id].endTime"
          />
        </div>
      </div>
    </div>

    <CurrentOrder ref="gameOrder"/>
  </div>
</template>

<script>
import API from "@/api";
import Countdown from "@/components/Countdown.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import SelectGameResult from "@/components/SelectGameResult.vue";
import socket from "@/socket/adminSocket";
import CurrentOrder from "@/components/Games/CurrentOrder.vue";

export default {
  components: {
    Countdown,
    SelectGameResult,
    CurrentOrder,
  },
  data() {
    return {
      productList: [],
      productSession: {},
    };
  },

  methods: {
    onUpdateCountdown(v) {
      console.log("update", v);
    },
    async getProductList() {
      try {
        const res = await this.$http(API.PRODUCT_LIST);
        if (res.success) {
          this.productList = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async onSelectedResult(value, product) {
      try {
        const res = await this.$http.patch(
          API.PRODUCT_RESULT + "/" + product._id,
          { result: value }
        );
        if (res.success) {
          Object.assign(product, res.data);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Cập nhật kết quả thành công",
              icon: "CheckIcon",
              variant: "success",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res.message,
              icon: "XIcon",
              variant: "danger",
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    onListGameInfoListener(data) {
      const productSession = data.reduce((prev, curr) => {
        prev[curr.id] = curr;
        return prev;
      }, {});
      this.productSession = productSession;
    },

    onGameInfoListener(data) {
      const { id } = data;
      const product = this.productSession[id];
      if (product) {
        Object.assign(product, data);
      }
      for (const p of this.productList) {
        if (p._id == id) {
          Object.assign(p, { result: "" });
        }
      }
      this.$refs['gameOrder'].resetData();
    },

    onNewOrder() {
      this.$refs['gameOrder'].fetchTableData(1);
    },
  },
  created() {
    console.log(123)
    this.getProductList()
    socket.emit('join-admin')
    socket.on('list-game-info', this.onListGameInfoListener)
    socket.on('game-info', this.onGameInfoListener)
    socket.on('new-order', this.onNewOrder)
  },
}
</script>
<style lang="scss" scoped>
.game-card {
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  // border: 2px solid;
  // border-radius: 8px;
  padding: 8px;

  position: relative;

  .game-card-title {
    font-weight: 500;
    margin-bottom: 8px;
    font-size: 18px;
  }

  .session {
    font-weight: bold;
    font-size: 14px;
  }
  .countdown-text {
    font-weight: bold;
    font-size: 20px;
  }
}
</style>
